import { Leaf, ChildrenAnalyzer } from "@contember/react-multipass-rendering";
import { Block } from "./Block.js";
const blockLeaf = new Leaf((node) => node.props, Block);
const blockAnalyzer = new ChildrenAnalyzer([blockLeaf], {
  ignoreUnhandledNodes: false,
  staticRenderFactoryName: "staticRender",
  unhandledNodeErrorMessage: "Only Block children are supported."
});
export {
  blockAnalyzer
};
//# sourceMappingURL=blockAnalyzer.js.map
